import { CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";

const Loading = (
  <MDBox
    sx={{ p: 2 }}
    display="flex"
    alignItems="center"
    justifyContent="center" // Centraliza horizontalmente
    height="100%" // Garante o uso do espaço vertical
    lineHeight={1}
  >
    <CircularProgress color="secondary" />
  </MDBox>
);

export { Loading };
